import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-762dc6d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 1,
  class: "text-h3 justify-center"
}
const _hoisted_3 = {
  key: 0,
  class: "text-bold align-center text-lg mt-2"
}
const _hoisted_4 = {
  key: 1,
  class: "subtitle"
}
const _hoisted_5 = {
  key: 2,
  class: "subtitle mt-2"
}
const _hoisted_6 = {
  key: 0,
  style: {"width":"100%"},
  class: "d-flex justify-center mb-2"
}
const _hoisted_7 = {
  style: {"padding":"16px 32px","background":"#F6F7F9","border-radius":"8px","border":"1px #D6DBE1 solid","justify-content":"space-between","align-items":"center","display":"inline-flex","min-width":"220px"},
  id: "v-step-show-hide"
}
const _hoisted_8 = {
  key: 0,
  class: "text-gray-500 text-sm me-4"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { style: {"color":"#292E36"} }, "Exibir", -1))
const _hoisted_10 = {
  key: 1,
  class: "text-gray-500 text-sm me-4"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { style: {"color":"#292E36"} }, "Esconder", -1))
const _hoisted_12 = { class: "d-flex flex-wrap" }
const _hoisted_13 = {
  class: "border border-gray-300 border-dashed rounded py-1 px-2 mb-2 mx-auto",
  style: {"min-width":"80%"},
  id: "v-step-user-info-margem"
}
const _hoisted_14 = { class: "d-flex align-items-center" }
const _hoisted_15 = { class: "fs-2 fw-bold d-flex counted mx-auto" }
const _hoisted_16 = {
  key: 0,
  class: "value-brl"
}
const _hoisted_17 = {
  key: 1,
  class: "value-brl"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-500 text-sm font-500 text-center" }, "Margem de Faturamento", -1))
const _hoisted_19 = {
  class: "border border-gray-300 border-dashed rounded py-1 px-2 mb-2 mx-auto",
  style: {"min-width":"80%"},
  id: "v-step-user-info-futura"
}
const _hoisted_20 = { class: "d-flex align-items-center" }
const _hoisted_21 = { class: "fs-2 fw-bold d-flex counted mx-auto" }
const _hoisted_22 = {
  key: 0,
  class: "value-brl"
}
const _hoisted_23 = {
  key: 1,
  class: "value-brl"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-500 text-sm font-500 text-center" }, "Comissão Futura", -1))
const _hoisted_25 = {
  class: "border border-gray-300 border-dashed rounded py-1 px-2 mb-4 mx-auto",
  style: {"min-width":"80%"},
  id: "v-step-user-info-disponivel"
}
const _hoisted_26 = { class: "d-flex align-items-center" }
const _hoisted_27 = { class: "fs-2 fw-bold d-flex counted mx-auto" }
const _hoisted_28 = {
  key: 0,
  class: "value-brl"
}
const _hoisted_29 = {
  key: 1,
  class: "value-brl"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-500 text-sm font-500 text-center" }, "Comissão Disponível", -1))
const _hoisted_31 = {
  class: "",
  id: "v-step-user-info-progresso"
}

import { ref } from 'vue';
import { AtomProgressBar, BRLIcon, ShowIcon, SlashEyeIcon } from '@/components/atoms';
import { MoleculeCard } from '@/components/molecules'
import { Authentication, Preloader } from '@/store';
import { iconShowValues } from '@/store/modules/subBar';

interface IProps {
  name: string;
  image: string;
  valueCommissionMonth: string;
  valueCommissionPlanned: string;
  month: string;
  profile: string;
  progress: number;
  futureComission: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeCardProgressUser',
  props: {
    name: {},
    image: {},
    valueCommissionMonth: {},
    valueCommissionPlanned: {},
    month: {},
    profile: {},
    progress: {},
    futureComission: {}
  },
  setup(__props: any) {

const props = __props;

function toggleValues()
{
  iconShowValues.value = !iconShowValues.value;
}

return (_ctx: any,_cache: any) => {
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_unref(MoleculeCard), {
    footer: "",
    divider: false
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_31, [
        _createVNode(_unref(AtomProgressBar), {
          modelValue: props.progress,
          progressColor: "#4CAF50",
          isTextBottom: "",
          title: "Progresso das metas no mês"
        }, null, 8, ["modelValue"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "12",
              class: "text-center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_avatar, {
                  color: "grey",
                  size: "150",
                  rounded: ""
                }, {
                  default: _withCtx(() => [
                    (props.image?.includes('http'))
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          style: {"width":"100%","height":"100%"},
                          src: props.image,
                          crossorigin: "anonymous"
                        }, null, 8, _hoisted_1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString((props.image ?? '').toUpperCase()), 1))
                  ]),
                  _: 1
                }),
                (_unref(Authentication).getters.isMasterOrAdmin.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(props.name), 1))
                  : _createCommentVNode("", true),
                (_unref(Authentication).getters.isMasterOrAdmin.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Valores referentes a " + _toDisplayString(_ctx.$props.month), 1))
                  : (_openBlock(), _createElementBlock("p", _hoisted_5, "Valores referentes a " + _toDisplayString(_ctx.$props.month), 1))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "12" }, {
              default: _withCtx(() => [
                (!_unref(Authentication).getters.isMasterOrAdmin.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        (_unref(iconShowValues))
                          ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
                              _hoisted_9,
                              _createTextVNode(" valores")
                            ]))
                          : (_openBlock(), _createElementBlock("p", _hoisted_10, [
                              _hoisted_11,
                              _createTextVNode(" valores")
                            ])),
                        (_unref(iconShowValues))
                          ? (_openBlock(), _createBlock(_unref(ShowIcon), {
                              key: 2,
                              width: 20,
                              height: 20,
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleValues()))
                            }))
                          : (_openBlock(), _createBlock(_unref(SlashEyeIcon), {
                              key: 3,
                              width: 20,
                              height: 20,
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleValues()))
                            }))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(_unref(BRLIcon), {
                          width: "28",
                          height: "30",
                          class: "me-1",
                          style: {"margin-top":"auto","margin-bottom":"auto"}
                        }),
                        (!_unref(iconShowValues))
                          ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(props.valueCommissionPlanned), 1))
                          : (_openBlock(), _createElementBlock("p", _hoisted_17, "******"))
                      ])
                    ]),
                    _hoisted_18
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_unref(BRLIcon), {
                          width: "28",
                          height: "30",
                          class: "me-1",
                          style: {"margin-top":"auto","margin-bottom":"auto"}
                        }),
                        (!_unref(iconShowValues))
                          ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(props.futureComission), 1))
                          : (_openBlock(), _createElementBlock("p", _hoisted_23, "******"))
                      ])
                    ]),
                    _hoisted_24
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _createVNode(_unref(BRLIcon), {
                          width: "28",
                          height: "30",
                          class: "me-1",
                          style: {"margin-top":"auto","margin-bottom":"auto"}
                        }),
                        (!_unref(iconShowValues))
                          ? (_openBlock(), _createElementBlock("p", _hoisted_28, _toDisplayString(props.valueCommissionMonth), 1))
                          : (_openBlock(), _createElementBlock("p", _hoisted_29, "******"))
                      ])
                    ]),
                    _hoisted_30
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})